import { Box, styledComponent, Typography } from '@hermes/web-components'

export const BookDetailsBody = styledComponent(Box)(({ theme }) => ({
  maxHeight: '500px',
  overflowY: 'auto',
  padding: '30px 24px 12px',
  [theme.breakpoints.down('xs')]: {
    padding: '33px 16px 12px'
  }
}))

export const DescriptionText = styledComponent(Typography)({
  fontSize: '14px',
  lineHeight: '20px',
  marginBottom: '20px'
})

export const BookHeaderInfo = styledComponent(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  marginBottom: '24px',
  [theme.breakpoints.down('xs')]: {
    marginBottom: '28px'
  }
}))

export const BookImageWrapper = styledComponent(Box)(({ theme }) => ({
  width: '260px',
  borderRadius: '8px',
  position: 'relative',
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    borderRadius: '12px'
  },
  marginRight: '24px',
  [theme.breakpoints.down('xs')]: {
    marginRight: '10px',
    width: '120px',
    height: '120px'
  }
}))

export const BookTitle = styledComponent(Typography)(({ theme }) => ({
  color: theme.palette.neutral[600],
  fontFamily: 'PT Serif',
  fontWeight: 700,
  fontSize: '28px',
  lineHeight: '36px',
  [theme.breakpoints.down('xs')]: {
    fontSize: '20px',
    lineHeight: '28px'
  }
}))
